import type { ReactNode } from 'react'

import {
    Archive,
    BarChart3,
    Calendar,
    CheckSquare,
    ClipboardList,
    Clock,
    ExternalLink,
    FolderKanban,
    FolderOpen,
    Gamepad2,
    Home,
    Link as LinkIcon,
    PartyPopper,
    PenLine,
    Scale,
    Settings,
    Trophy,
    User,
    Users,
} from './components/icon/solar-icons.js'

/**
 * Single source of truth for sidebar / drawer nav icons, keyed by route path.
 * Used by the desktop shell sidebar+header tabs and the mobile drawer so the two
 * never drift. All icons use the BoldDuotone weight for a consistent filled look
 * across desktop and mobile. Unknown paths fall back to a generic File icon at
 * the call site.
 */
export const navIcons: Record<string, ReactNode> = {
    '/': <Home size={18} weight="BoldDuotone" />,
    '/me/tasks': <CheckSquare size={18} weight="BoldDuotone" />,
    '/people': <Users size={18} weight="BoldDuotone" />,
    '/calendar': <Calendar size={18} weight="BoldDuotone" />,
    '/me/documents': <FolderOpen size={18} weight="BoldDuotone" />,
    '/reports': <BarChart3 size={18} weight="BoldDuotone" />,
    '/audit-log': <ClipboardList size={18} weight="BoldDuotone" />,
    '/settings': <Settings size={18} weight="BoldDuotone" />,
    '/me': <User size={18} weight="BoldDuotone" />,
    '/me/time-away': <Calendar size={18} weight="BoldDuotone" />,
    '/me/settings': <Settings size={18} weight="BoldDuotone" />,
    'google-drive-external': <ExternalLink size={18} weight="BoldDuotone" />,
    '/badges': <Gamepad2 size={18} weight="BoldDuotone" />,
    '/events': <PartyPopper size={18} weight="BoldDuotone" />,
    '/leaderboard': <Trophy size={18} weight="BoldDuotone" />,
    '/url-shortener': <LinkIcon size={18} weight="BoldDuotone" />,
    '/signaturetool': <PenLine size={18} weight="BoldDuotone" />,
    '/balancetime': <Scale size={18} weight="BoldDuotone" />,
    '/me/balancetime': <Clock size={18} weight="BoldDuotone" />,
    '/me/worktime': <FolderKanban size={18} weight="BoldDuotone" />,
    '/me/assets': <Archive size={18} weight="BoldDuotone" />,
}
